import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { getApiUrl, BASE_URL } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import placeholder from "../assets/sampleimage.png";

const SimpleVerticalBanner = () => {
  const [banners, setBanners] = useState([]);

  const fetchBanners = async () => {
    try {
      const res = await fetch(getApiUrl("advertisementbanner-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const result = await res.json();
      if (result.success) {
        setBanners(result.data || []);
      }
    } catch (err) {
      toast.error("Failed to load banners");
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  return (
   <div className="container">
      {banners.length > 0
        ? banners.map((banner, index) => (
            <img
              key={index}
              src={banner ? `${BASE_URL}${banner}` : placeholder}
              alt={`Banner ${index + 1}`}
              style={{ width: "100%", height: "auto", marginBottom: "10px" }}
            />
          ))
        : (
            <img
              src={placeholder}
              alt="Placeholder"
              style={{ width: "100%", height: "auto", marginBottom: "10px" }}
            />
          )}
    </div>
  ); 
};

export default SimpleVerticalBanner;
